import React, { useEffect, useRef, useState } from "react";
import { Drawer } from "rsuite";
import "../../assets/style/EmployeeProfile/ProfileDrawer.css";
import ProfileAccordion from "./ProfileAccordion";
import { Button, CoreLoader, Input } from "common/components";
import { format } from "date-fns";
import apiManager from "networking/baseAPIManager";
import moment from "moment";
import "../../assets/style/profileEditicon.css";
import userImage from "../../assets/images/UserDefultImage.png";
const ProfileDrawer = ({ setOpen, data, open }) => {
  const [candidateData, setCandidateData] = useState({});
  const [fileData, setFileData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [openFile, setOpenFile] = useState(false);

  let BASE_URL = process.env.REACT_APP_BASE_URL;
  let fullName = data.firstname + " " + data.lastname;
  const isOnLeave = data.start_date && data.end_date;
  let empid = data?._id;

  const moment = require("moment");

  const dateOfJoin = moment(candidateData.createdAt).format("ll");
  const startDate = moment(data.start_date).format("DD MMM YYYY");
  const endDate = moment(data.end_date).format("DD MMM YYYY");

  useEffect(() => {
    if (empid) {
      getAllDataCandidate();
    }
  }, [empid]);
  useEffect(() => {
    if (fileData) {
      changeProfilePicture();
    }
  }, [empid, fileData]);

  const getAllDataCandidate = () => {
    setLoader(true);
    apiManager
      .candidateAllData(empid)
      .then((res) => {
        setCandidateData(res?.data);
      })
      .catch((err) => {
        console.log(err, "api Error all Data");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  if (!empid) {
    return;
  }
  const handleEditClick = () => {
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    }
  };

  const changeProfilePicture = () => {
    if (fileData) {
      let formData = new FormData();
      formData.append("empid", empid);
      formData.append("image", fileData);
      apiManager
        .updateEmployee(formData)
        .then((response) => {
          console.log(response, "response");
          getAllDataCandidate();
        })
        .catch((error) => {
          console.log(error, "error");
        });
    }
  };

  return (
    <>
      <Drawer open={open} onClose={() => setOpen(false)} size="md">
        <Drawer.Header className="drawer-Header">
          <Drawer.Title className="d-flex justify-content-center ">
            <b>Employee Profile</b>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <div className="container-fluid d-flex flex-column h-100 mb-2">
            <div className="ps-4">
              <div className="row mt-3">
                <div className="col-lg-6 justify-content-center">
                  <img
                    className="drawerUserImage "
                    src={candidateData?.image ? `${BASE_URL}/${candidateData?.image}` : userImage}
                  />
                  <div className="profileEdit" onClick={handleEditClick}>
                    <div>
                      <input
                        id="fileInput"
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          setFileData(e.target.files[0]);
                        }}
                      />
                      <span className="material-symbols-outlined pointer p-2 bg-primary-subtle border border-primary-subtle rounded-circle">
                        edit
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <h4>{fullName}</h4>
                  <p>
                    Employee Department :{" "}
                    <span className="text-primary">{candidateData.department ? candidateData.department : "N/A"}</span>
                  </p>
                  <p>
                    Employee ID :
                    <span className="text-primary">{candidateData.employeeID ? candidateData.employeeID : "N/A"}</span>
                  </p>
                  <p className="text-primary">Date of Join :{dateOfJoin} </p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-12  ">
                  <ul className="drawerUserDetail ps-0">
                    <li className="row">
                      <span className="col-lg-6">Phone :</span>
                      <span className="col-lg-6 text-dark-emphasis">{candidateData.mobile_number}</span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6">Email :</span>
                      <span className="col-lg-6 text-dark-emphasis">{candidateData.company_email}</span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6">Birthday :</span>
                      <span className="col-lg-6 text-dark-emphasis">{candidateData.documentDob}</span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6">Office Location :</span>
                      <span className="col-lg-6 text-dark-emphasis">
                        {candidateData.worklocation &&
                        candidateData.worklocation.cityname &&
                        candidateData.worklocation.countryname
                          ? `${candidateData.worklocation.cityname} (${candidateData.worklocation.countryname})`
                          : "N/A"}
                      </span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6">Gender :</span>
                      <span className="col-lg-6 text-dark-emphasis">{candidateData.gender}</span>
                    </li>
                    {/* <li className="row">
                      <span className="col-lg-6">Reports to :</span>
                      <span className="col-lg-6 text-dark-emphasis">{candidateData.reports}</span>
                    </li> */}
                    {isOnLeave && (
                      <li className="row">
                        <span className="col-lg-6">On Leave:</span>
                        <span className="col-lg-6 text-dark-emphasis">
                          {startDate} To {endDate}
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-auto pb-4">
              <ProfileAccordion data={candidateData} />
            </div>
            <div className="pb-2 d-flex justify-content-center">
              <Button label="Close" onClick={() => setOpen(false)} />
            </div>
          </div>
        </Drawer.Body>
      </Drawer>
      <CoreLoader show={loader} disableLines />
    </>
  );
};

export default ProfileDrawer;
